import { useSelector } from 'react-redux'

// Types
import { State, EntityState, Discount } from 'types'

export const useDiscounts = (): EntityState<Discount> => {
  return useSelector<State, EntityState<Discount>>(state => state.entities.discounts)
}

export const useIsFreeTrack = (trackId: number): boolean => {
  const discounts = useDiscounts()
  const discountList = Object.keys(discounts).map(key => discounts[key])
  return !!discountList.find(discount => (discount.type === 'track' && discount.object_id === +trackId) || discount.type === 'alltracks')
}
